import {
  clearOldInteractionsEntries,
  STORAGE_KEYS,
  universalTrackRoomClicked,
} from '@/services/interactions-tracker';

export function trackRoomClicked(roomId) {
  universalTrackRoomClicked(STORAGE_KEYS.SIMILAR_ROOM, roomId);
}

export function clearOldSimilarRoomsInteractionsEntries() {
  clearOldInteractionsEntries(STORAGE_KEYS.SIMILAR_ROOM);
}
